// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store';
import VeeValidate from 'vee-validate';

import './assets/fontawesome-pro-5.6.3-web/css/all.css'
import './assets/fontawesome-pro-5.6.3-web/css/fontawesome.min.css'
import './assets/fontawesome-pro-5.6.3-web/css/fontawesome.css'
import './assets/fontawesome-pro-5.6.3-web/css/light.css'
import './assets/fontawesome-pro-5.6.3-web/css/light.min.css'
import './assets/fontawesome-pro-5.6.3-web/css/regular.css'
import './assets/fontawesome-pro-5.6.3-web/css/regular.min.css'
import './assets/fontawesome-pro-5.6.3-web/css/solid.css'
import './assets/fontawesome-pro-5.6.3-web/css/solid.min.css'
import './assets/fontawesome-pro-5.6.3-web/css/svg-with-js.css'
import './assets/fontawesome-pro-5.6.3-web/css/svg-with-js.min.css'
import './assets/fontawesome-pro-5.6.3-web/css/v4-shims.css'
import './assets/fontawesome-pro-5.6.3-web/css/v4-shims.min.css'
import './assets/fontawesome-pro-5.6.3-web/css/all.min.css'
import './assets/fontawesome-pro-5.6.3-web/css/brands.css'
import './assets/fontawesome-pro-5.6.3-web/css/brands.min.css'
Vue.config.productionTip = false
Vue.use(VeeValidate);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js